import { configureStore } from '@reduxjs/toolkit';
import errorMiddleware from './middlewares/errorMiddleware';
import AuthReducer from './reducers/auth.reducer';
import SupplierReducer from './reducers/supplier.reducer';
import TextureReducer from './reducers/texture.reducer';
import ModuleReducer from './reducers/module.reducer';
import SaleProductReducer from './reducers/sale-product.reducer';
import CategoryReducer from './reducers/category.reducer';
import ProductReducer from './reducers/product.reducer';
import DuluxPaleteReducer from './reducers/dulux-palete.reducer';
import InsideAccessoryReducer from './reducers/insideAccessory.reducer';
import AddressReducer from './reducers/address.reducer';
import MaterialReducer from './reducers/material.reducer';
import DoorHandleReducer from './reducers/door.handle.reducer';
import RoomReducer from './reducers/room.reducer';
import AdminRoomReducer from './reducers/admin.room.reducer';
import CampaignReducer from './reducers/campaign.reducer';
import QuotationReducer from './reducers/quotation.reducer';
import defaultConfigReducer from './reducers/default.config.reducer';
import adminUserReducer from './reducers/admin.user.reducer';
import LiftSupportReducer from './reducers/liftSupport.reducer';
import DimensionReducer from './reducers/dimension.reducer';

// import * as Sentry from '@sentry/react';

export default configureStore({
  reducer: {
    auth: AuthReducer,
    product: ProductReducer,
    duluxPalete: DuluxPaleteReducer,
    category: CategoryReducer,
    supplier: SupplierReducer,
    texture: TextureReducer,
    module: ModuleReducer,
    saleProduct: SaleProductReducer,
    insideAccessory: InsideAccessoryReducer,
    address: AddressReducer,
    materialReducer: MaterialReducer,
    doorAndHandle: DoorHandleReducer,
    liftSupport: LiftSupportReducer,
    room: RoomReducer,
    adminRoom: AdminRoomReducer,
    campaign: CampaignReducer,
    quotation: QuotationReducer,
    defaultConfig: defaultConfigReducer,
    adminUser: adminUserReducer,
    dimension: DimensionReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(errorMiddleware),
  // enhancers: defaultEnhancers =>
  //   defaultEnhancers.concat(Sentry.createReduxEnhancer()),
});
